import { constantsData, formFieldNamesData } from "@/data";
import { optionsData } from "@/data/options";
import { AsyncDataKeyEnum, FieldTypeEnum, InputTypeEnum } from "@/enums";

const {
    balanceType,
    category,
    currency,
    description,
    hierarchy,
    name,
    number,
    parentAccount,
    startingBalance,
    startingBalanceDate,
    status,
} = constantsData.forms.accounts.account;

const {
    account: accountFieldName,
    balanceType: balanceTypeFieldName,
    category: categoryFieldName,
    currency: currencyFieldName,
    description: descriptionFieldName,
    hierarchy: hierarchyFieldName,
    name: nameFieldName,
    number: numberFieldName,
    startingBalance: startingBalanceFieldName,
    startingBalanceDate: startingBalanceDateFieldName,
    status: statusFieldName,
} = formFieldNamesData;

export const accountFormData = [
    {
        description: name.description,
        label: name.label,
        name: nameFieldName,
        type: InputTypeEnum.TEXT,
    },
    {
        description: number.description,
        isDisabled: true,
        isOptional: true,
        label: number.label,
        name: numberFieldName,
        type: InputTypeEnum.TEXT,
    },
    {
        description: hierarchy.description,
        label: hierarchy.label,
        name: hierarchyFieldName,
        tabsLabels: {
            labels: {
                parent: `${optionsData.account.hierarchies[0]} Account`,
                sub: `${optionsData.account.hierarchies[1]} Account`,
            },
            type: hierarchyFieldName,
        },
        type: FieldTypeEnum.TABS,
    },
    {
        dataKey: AsyncDataKeyEnum.ACCOUNTS,
        description: parentAccount.description,
        isAsync: true,
        label: parentAccount.label,
        name: accountFieldName,
        type: FieldTypeEnum.SELECT,
    },
    {
        description: balanceType.description,
        isDisabled: true,
        label: balanceType.label,
        name: balanceTypeFieldName,
        tabsLabels: {
            labels: {
                credit: optionsData.balanceTypes[1],
                debit: optionsData.balanceTypes[0],
            },
            type: balanceTypeFieldName,
        },
        type: FieldTypeEnum.TABS,
    },
    {
        dataKey: AsyncDataKeyEnum.CURRENCIES,
        description: currency.description,
        isAsync: true,
        isDisabled: true,
        label: currency.label,
        name: currencyFieldName,
        type: FieldTypeEnum.SELECT,
    },
    {
        dataKey: AsyncDataKeyEnum.CATEGORIES,
        description: category.description,
        hasOptionFormat: true,
        isAsync: true,
        isDisabled: true,
        label: category.label,
        name: categoryFieldName,
        type: FieldTypeEnum.SELECT,
    },
    {
        description: startingBalance.description,
        isDisabled: true,
        isOptional: true,
        label: startingBalance.label,
        name: startingBalanceFieldName,
        type: InputTypeEnum.NUMBER,
    },
    {
        description: startingBalanceDate.description,
        isDisabled: true,
        isOptional: true,
        label: startingBalanceDate.label,
        name: startingBalanceDateFieldName,
        tooltipText: startingBalanceDate.tooltip,
        type: FieldTypeEnum.DATE,
    },
    {
        description: description.description,
        isOptional: true,
        label: description.label,
        name: descriptionFieldName,
        type: FieldTypeEnum.TEXTAREA,
    },
    {
        description: status.description,
        isOptional: true,
        label: status.label,
        name: statusFieldName,
        switchLabels: {
            active: optionsData.account.status.options[0],
            inactive: optionsData.account.status.options[1],
        },
        type: FieldTypeEnum.SWITCH,
    },
];
